module.exports = __webpack_public_path__ + "static/media/info.838f217b.svg";